import { notification } from 'antd';
import { GET_SETTINGS, UPDATE_SETTINGS } from 'admin/constants';
import { API_ENDPOINTS } from 'common/constants';

export function getSettings() {
	return async dispatch => {
		await dispatch({
			type: GET_SETTINGS.START,
			url: API_ENDPOINTS.getSettings,
			method: 'GET',
			onSuccess: res => dispatch({ type: GET_SETTINGS.SUCCESS, payload: { ...res.data } }),
			onFail: () => dispatch({ type: GET_SETTINGS.FAIL }),
		});
	};
}

export function updateSettings(data) {
	return async dispatch => {
		const onSuccess = () => dispatch({ type: UPDATE_SETTINGS.SUCCESS, payload: { ...data } });
		const onFail = err => {
			notification.error({
				message: 'Error!',
				description: err.message,
			});
			dispatch({ type: UPDATE_SETTINGS.FAIL });
		};

		dispatch({
			type: UPDATE_SETTINGS.START,
			url: API_ENDPOINTS.updateSettings,
			payload: data,
			secure: true,
			onSuccess,
			onFail,
		});
	};
}
